<template>
  <div>
    <div class=" w-full mt-2">
      <p class="font-black text-xs mb-2 uppercase">
        {{ title }}
      </p>
      <div class="line"></div>
    </div>
    <table aria-label="other benefits table" class=" w-full">
      <thead>
        <tr>
          <th id="0">#</th>
          <th class=" uppercase" v-for="(header, index) in headers" :key="index" :id="index">
            <p>{{ header.title }}</p>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(data, i) in paySettingsData" :key="i" class="tableBody text-sm" style="height: 48px; ">
          <td>
            {{ i + 1 }}
          </td>
          <td>
            {{ data.payItem.name }}
          </td>
          <td>
            {{ data.nameOnPayslip }}
          </td>
          <td>
            {{ Capitalize(data.payType) }}
          </td>
          <td>
            {{ data.rateType.label }}
          </td>
          <td>
            <c-text v-if="data.isEdit" placeholder="" type="number" v-model="data.employeeSetting.rateValue" :disabled="!canEdit" />
            <span v-else>
              {{ data.rateType.label.includes("%") ? `${data.employeeSetting?.rateValue}%`:
                convertToCurrency(data.employeeSetting?.rateValue)}}
            </span>
          </td>
          <td v-if="!isBasic">
            <div v-if="data.allowValueFormulaOverride">
              <div v-if="data.isEdit" @click="editRateValue(data.id, title)">
                <icon icon-name="close-icon" size="s" :class="canEdit ? `w-4 h-4 cursor-pointer` : `w-4 h-4`"/>
              </div>
              <div v-else-if="!data.isEdit" @click="editRateValue(data.id, title)">
                <icon icon-name="red-edit" size="s" :class="canEdit ? `w-4 h-4 cursor-pointer` : `w-4 h-4`"/>
              </div>
            </div>
            <div v-else>
              <icon icon-name="red-padlock" size="s" class="w-5 h-5"/>
            </div>
          </td>
        </tr>
        <tr class="h-7" />
      </tbody>
    </table>
  </div>
</template>

<script>
import CText from "@scelloo/cloudenly-ui/src/components/text";

export default {
  components: { CText },
  props: {
    title: {
      type: String,
      default: ""
    },
    paySettingsData: {
      type: Array,
      default() {
        return [];
      }
    },
    canEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      edit: false,
      headers: [
        { title: "pay item" },
        { title: "name in payslip" },
        { title: "pay type" },
        { title: "rate type" },
        { title: "Rate value" },
        { title: " " }
      ],
    };
  },
  computed: {
    isBasic() {
      return (
        this.$store.state.subscription &&
        this.$store.state.subscription.plan === "basic"
      );
    },
  },
  methods: {
    editRateValue(id, title){
      this.$emit('edit-RateValue', id, title)
    }
  }
};
</script>

<style scoped>
.line{
  border: 0.5px solid #00000029;
  width: 100%;
  height: 0;
  margin: 10px auto;
  border-radius: 10px;
  padding: 0;
}
</style>
